import React from "react";
import { t } from "ttag";

import { money } from "../../../utils/format";
import { IBasket } from "../models.interfaces";
import { getBasketTotal } from "../utils";

type IProps = IBasket;

const buildLines = (lines: IBasket["lines"]): React.ReactNode => {
    if (lines.length <= 0) {
        return (
            <tr>
                <td colSpan={7}>
                    <em>Basket is empty</em>
                </td>
            </tr>
        );
    }
    return lines.map((line) => {
        return (
            <tr key={line.id}>
                <td>{line.id}</td>
                <td>{line.product.title}</td>
                <td>{line.product.attribute_summary || "-"}</td>
                <td>{line.quantity}</td>
                <td>{money(line.price_excl_tax)}</td>
                <td></td>
            </tr>
        );
    });
};

export const CustomerDetailsBasket = (props: IProps): React.ReactNode => {
    const created = props.date_created
        ? new Date(props.date_created).toLocaleString()
        : "-";
    const merged = props.date_merged
        ? new Date(props.date_merged).toLocaleString()
        : "-";
    const submitted = props.date_submitted
        ? new Date(props.date_submitted).toLocaleString()
        : "-";
    const totalExclTax = getBasketTotal(props);
    return (
        <div className="csr-customer-basket">
            <div className="csr-customer-basket__basic">
                <table>
                    <thead>
                        <tr>
                            <th colSpan={2}>{t`Basic Details`}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>{t`Status`}</th>
                            <td>{props.status}</td>
                        </tr>
                        <tr>
                            <th>{t`Total (excl. Tax)`}</th>
                            <td>{money(totalExclTax)}</td>
                        </tr>
                        <tr>
                            <th>{t`Date Created`}</th>
                            <td>{created}</td>
                        </tr>
                        <tr>
                            <th>{t`Date Merged`}</th>
                            <td>{merged}</td>
                        </tr>
                        <tr>
                            <th>{t`Date Submitted`}</th>
                            <td>{submitted}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="csr-customer-basket__lines">
                <h2>Lines</h2>
                <table>
                    <thead>
                        <tr>
                            <th>{t`Line ID`}</th>
                            <th>{t`Product`}</th>
                            <th>{t`Options`}</th>
                            <th>{t`Quantity`}</th>
                            <th>{t`Line Price (excl. Tax)`}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>{buildLines(props.lines)}</tbody>
                </table>
            </div>
        </div>
    );
};
